"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M23.8 7.2a6.8 6.8 0 0 0-13.6 0v13.6a6.8 6.8 0 1 0 13.6 0z" }),
  React.createElement("path", { d: "M28 21v-4.5a.5.5 0 0 0-.5-.5h-.9a.5.5 0 0 0-.5.5v4.256a9.315 9.315 0 0 1-8.476 9.4A9.11 9.11 0 0 1 7.9 21.078V16.5a.5.5 0 0 0-.5-.5h-.9a.5.5 0 0 0-.5.5v4.177a11.215 11.215 0 0 0 9.94 11.273H16V34H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H18v-2.058A11.007 11.007 0 0 0 28 21z" })
);

